import React from "react";
import { sortByOrderAscending } from "../../helper/helper";
const HoppersRestaurantGalleryPage = ({ components }) => {
    const getComponents = (component) => {
        switch (component.ID) {
            case "HoppersRestaurantGalleryPage-header":
                return <div className="HoppersRestaurantGalleryPage-header">{component?.Props?.text}</div>
            case "HoppersRestaurantGalleryPage-subheader":
                return <div className="HoppersRestaurantGalleryPage-subheader">{component?.Props?.text}</div>
            case "HoppersRestaurantGalleryPage-grid":
                return <div className="HoppersRestaurantGalleryPage-grid">
                    {component?.Data?.map((data, key) => {
                        return (
                            <img
                                src={data?.src}
                                key={key}
                                alt=""
                                className="HoppersRestaurantGalleryPage-grid-image" />
                        )
                    })}
                </div>
            default:
                return <div />
        }

    }
    return (
        <div className="HoppersRestaurantGalleryPage">
            {sortByOrderAscending(components).map((component, key) => {
                return (
                    getComponents(component)
                )
            })}
        </div>
    )
}
export default HoppersRestaurantGalleryPage